<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.99005 4.42715C9.88207 3.89245 9.11781 3.89245 9.00983 4.42715L8.28295 8.0267C8.24831 8.19824 8.1265 8.33919 7.96179 8.39832L4.81079 9.52952C4.36938 9.68799 4.36938 10.3122 4.81079 10.4707L7.96179 11.6019C8.1265 11.661 8.24831 11.802 8.28295 11.9735L9.00983 15.5731C9.11781 16.1078 9.88207 16.1078 9.99005 15.5731L10.7169 11.9735C10.7516 11.802 10.8734 11.661 11.0381 11.6019L14.1891 10.4707C14.6305 10.3122 14.6305 9.68799 14.1891 9.52952L11.0381 8.39832C10.8734 8.33919 10.7516 8.19824 10.7169 8.0267L9.99005 4.42715Z"
            fill="url(#paint0_linear_6654_3675)"
        />
        <path
            d="M17.49 12.4272C17.3821 11.8924 16.6178 11.8924 16.5098 12.4272L16.1012 14.451C16.0665 14.6225 15.9447 14.7635 15.78 14.8226L13.8108 15.5295C13.3694 15.688 13.3694 16.3122 13.8108 16.4707L15.78 17.1776C15.9447 17.2368 16.0665 17.3777 16.1012 17.5493L16.5098 19.5731C16.6178 20.1078 17.3821 20.1078 17.49 19.5731L17.8987 17.5493C17.9334 17.3777 18.0552 17.2368 18.2199 17.1776L20.1891 16.4707C20.6305 16.3122 20.6305 15.688 20.1891 15.5295L18.2199 14.8226C18.0552 14.7635 17.9334 14.6225 17.8987 14.451L17.49 12.4272Z"
            fill="url(#paint1_linear_6654_3675)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_6654_3675"
                x1="4.47974"
                y1="4.02612"
                x2="4.47974"
                y2="19.9741"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#18EC81" />
                <stop offset="0.424315" stop-color="#0DACBA" />
                <stop offset="1" stop-color="#0A3DFF" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_6654_3675"
                x1="4.47974"
                y1="4.02612"
                x2="4.47974"
                y2="19.9741"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#18EC81" />
                <stop offset="0.424315" stop-color="#0DACBA" />
                <stop offset="1" stop-color="#0A3DFF" />
            </linearGradient>
        </defs>
    </svg>
</template>
